
const AppSettings = {
  appTitle: 'N25',
  siteAdmin: 'tripti.soni@atkinsglobal.com',
  baseUrl: 'https://europe-west2-n25-pinpoint-ae83d.cloudfunctions.net/functions/',
  showFeedbackButton: false,
  showPostcodeFilter : false,
  showHelp: false,
  showUser: true,
  enableFilter: false,
  enableChildrenCount: false,
  enableEntityPopup: true,
  feedbackType: 'form',
  mapConfig: {
      accessToken:
        "pk.eyJ1IjoiY3JlYXRpdmUtZGVzaWduIiwiYSI6ImNqYXY0d3h2eTZ5M2syd2w5eWo3Ymd5bGIifQ.cYdELtP5xXELeUZ0p_cS_g",
      templatename: "mapbox://styles/creative-design/ck7d594mn030d1ipnn7fsnuf5/draft", //"mapbox://styles/mapbox/light-v10", //"mapbox://styles/mapbox/basic-v9?optimize=true",
      startLocation: [-7.014533366259798,52.31575449555319],//[-0.457619, 51.4712667],
      startZoom: 11,
      startPitch: 60
     
    },

}; 

export default AppSettings;

